var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid p-3 min-vh-100",attrs:{"id":"app"}},[_c('Header'),(this.$route.path !== `/` && this.$route.path !== `/404`)?_c('NavBar'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }